
import React,{ useContext }from "react";
import "./css/chooseproduct.css";
import ImageLoader from "./imageloader";
import { useTranslation } from 'react-i18next';
import {StateAmbContext} from '../../stateContext';

export default function ChooseProduct(props) {
   
    const { settings } = useContext(StateAmbContext);
    const { t, i18n } = useTranslation();
    return (
        <>
        <div className="row m-0">
        {/* <Header /> */}

            <div className="col-sm-12 bg-head">
                <div className="custom_container p-0">
                <p className="p_select">{t('choose_pdt.product_selector')}</p>
                <b className="font32">{t('choose_pdt.first_statement')}:</b>
                </div>
            </div>
            <div className="custom_container m-auto ">
                <div className="card-deck card-homemain">
                    <div className="card"  onClick={()=>{props.navigate("buildcu")}}>
                    <div className="text-center card-img-top "  >  
                   <ImageLoader  product={"cu_unit"} />
                    </div>
                        <div className="card-body titlest"  >
                            <h4 className="card-title">{t('unit_names.condensing_unit')}</h4>
                            <b>{t('choose_pdt.pdts_available')}:</b>
                            <p className="card-text">• {t('choose_pdt.cu_desc')}</p>

                        </div>
                    </div>
                    <div className="card "  onClick={()=>{props.navigate("builduc")}}>
                    <div className="text-center card-img-top "  > 
                    <ImageLoader product={"uc_unit"} />
                    </div>
                        <div className="card-body titlest"  >
                            <h4 className="card-title">{t('unit_names.evap_unit')}</h4>
                            <b>{t('choose_pdt.pdts_available')}</b>
                            <ul className="card-text">
                                <li>{t('choose_pdt.uc_desc_LOP')}</li>
                                <li>{t('choose_pdt.uc_desc_LVCM')}</li>
                                <li>{t('choose_pdt.uc_desc_CM')}</li></ul>
                        </div>
                    </div>
                    <div className="card" onClick={()=>{props.navigate("buildsystem")}}>
                    <div className="text-center card-img-top "  > 
                    <ImageLoader product={"system_unit"}/>
                        </div>
                        <div className="card-body titlest "  >
                            <h4 className="card-title">{t('unit_names.system')}</h4>
                            <p className="card-text">{t('choose_pdt.system_desc')} </p>
                        </div>
                    </div>


                </div>
                <div className="text-center font-15 pos10">
                    {
                        settings.is_hub? <p>{t('choose_pdt.footer_hub')}</p> :

                    <p>{t('choose_pdt.footer.visit_1')} {" "}
                                    <a href="https://hub.heatcraftrpd.com" target="_blank" className="color-blue font-bold">
                                        https://hub.heatcraftrpd.com</a> {" "}
                                     {t('choose_pdt.footer.visit_2')}</p>
                    }
                </div>
            </div>

        </div>
        </>
    );
}
